import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";

export default function Links() {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-6 py-8 mb-20">
        <div className="mb-6">
          <h4 className="text-xl font-bold">
            Members of UNGEGN Asia South-East Division (ASE Division)
          </h4>
        </div>

        {/* Baris 1 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/9/91/Flag_of_Bhutan.svg"
            alt="Bhutan Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Brunei.svg"
            alt="Brunei Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_Cambodia.svg"
            alt="Cambodia Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg"
            alt="Indonesia Flag"
          />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 text-center">
          <a
            class="hover:underline hover:text-blue-600"
            href="https://www.nlcs.gov.bt/?page_id=80"
          >
            <h5>Bhutan</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.mod.gov.bn/survey/Theme/Home.aspx"
          >
            <h5>Brunei Darussalam</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.mlmupc.gov.kh/"
          >
            <h5>Cambodia</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="https://www.big.go.id/"
          >
            <h5>Indonesia</h5>
          </a>
        </div>

        {/* Baris 2 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 mb-5">
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg"
            alt="Laos Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/6/66/Flag_of_Malaysia.svg"
            alt="Malaysia Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/8/8c/Flag_of_Myanmar.svg"
            alt="Myanmar Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_the_Philippines.svg"
            alt="Philippines Flag"
          />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 text-center">
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.ngd.la/?lang=en"
          >
            <h5>Lao People's Democratic Republic</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.mygeoportal.gov.my/"
          >
            <h5>Malaysia</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.surveydepartment.gov.mm/eng/"
          >
            <h5>Myanmar</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://www.namria.gov.ph/"
          >
            <h5>Philippines</h5>
          </a>
        </div>

        {/* Baris 3 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 mb-5">
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Singapore.svg"
            alt="Singapore Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/1/11/Flag_of_Sri_Lanka.svg"
            alt="Sri Lanka Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg"
            alt="Thailand Flag"
          />
          <img
            className="flag-image"
            src="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
            alt="Vietnam Flag"
          />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 text-center">
          <a
            class="hover:underline hover:text-blue-600"
            href="https://www.sla.gov.sg/"
          >
            <h5>Singapore</h5>
          </a>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://survey.gov.lk/"
          >
            <h5>Sri Lanka</h5>
          </a>
          <h5>Thailand</h5>
          <a
            class="hover:underline hover:text-blue-600"
            href="http://dosm.gov.vn/"
          >
            <h5>Vietnam</h5>
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
}
